import React, { memo, useEffect, useState } from "react";
import "./DashboardSummary.css";
// import { DashboardShortcuts } from "../Index";
import { Config } from "../../../../Utils/Config";
import axios from "axios";
import { handlingCatchError } from "../../../../Utils/ErrorHandling";

import { useNavigate, useLocation } from "react-router-dom";
import classnames from "classnames";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import {
  Nav,
  NavLink,
  NavItem,
  TabContent,
  TabPane,
  Row,
  Col,
} from "reactstrap";
import AmenitiesAnalysis from "../AmenitiesAnalysis/AmenitiesAnalysis";
import Seasonality from "../Seasonality/Seasonality";
import { CampClassification } from "../CampClassification/Index";
import PricingAnalysis from "../PricingAnalysis/PricingAnalysis";
import  Activity from '../Activities/Activity'
import { TableBody, TableContainer, TableHead, Table, TableCell, TableRow } from "@mui/material";
import { updateObjectValues } from "../../../../helpers/dataHelper";
import { apiCommonTrigger } from "../../../../Utils/apiServicehelper";
let summary;

const reqHeaderText = {
  rvparksinmarket: "RV Parks in market",
  totalrvparksites: "Total Camping spots",
  avgpricepernight: "Average price per night",
  countofhousehold: "Households",
  demandsupplyratioformarket: "Demand Supply Ratio",
  rvparkdemandscoreformarket: "RV Park Demand Score For Market",
  rvparkdemandscorefornational: "RV Park Demand Score For National",
  avgsizeofpark: "Average Size Of Park",
  rvownershipinmarket: "RV Ownership in market",
  population: "Population",
  populationdensity: "Population Density(per sq mi)",
  regiontype: "Region Type",
  incomepercapita: "Income per capita",
  avgfuelcost: "Averge Fuel Cost",
  avgage: "Average Age",
  fivetotwentyfour: "Population age from 5-24",
  twentyfivetofortyfour: "Population age from 25-44",
  fortyfivetofiftyfour: "Population age from 45-54",
  fiftyfivetoseventyfour: "Population age from 55-74",
  seventyfiveandabove: "Population age of 75 And Above",
  marketscore: "Market Score",
  potentialcampers: "Potential Campers based on Demand",
};



const DashboardSummary = memo((props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [marketSummary, setMarketSummary] = useState({});
  const [tabValue, setTabValue] = useState({ active: "1" });

 // const marketId = location && location.state && location.state.marketId ? location.state.marketId : null;
 const marketId = location.pathname.split("/").pop();
  //handle change for tab selection
  const handleTabChange = (tab) => {
    if (tabValue.active !== tab) {
      if (tab === "1") setTabValue({ active: tab });
      else setTabValue({ ...tabValue, active: tab });
    }
  };

  useEffect(() => {
    if (Object.keys(props.data).length > 0) {
    getMarketSummary();
    }else{
      if(!props.getBasicDetails) return true;
      props.getBasicDetails(props.marketId);
    }
    //getMarketSummary();
  }, [props.data, props.marketId])

  const getMarketSummary = () => {
    setLoading(true);
    apiCommonTrigger("get", Config.API_URL + "/markets/market/analysis/" , [marketId])
      .then((res) => {
        setLoading(false);
        if (res.status === 200) {
          setMarketSummary({ ...marketSummary, marketsummaryresult: res.data });
        }
        else{
          handlingCatchError(res, navigate);
        }
      })
      .catch(err => {
        handlingCatchError(err, navigate);
      })
  }



  //get parks summary details
  const getSummaryDetails = () => {
    summary = [];
    let summaryDetails = updateObjectValues(marketSummary.marketsummaryresult.summaryformarket);
    let summaryFor50Miles = updateObjectValues(marketSummary.marketsummaryresult.summaryfor50miles) || null;
    let summaryfor100miles = updateObjectValues(marketSummary.marketsummaryresult.summaryfor100miles) || null;
    let summaryForNational = updateObjectValues(marketSummary.marketsummaryresult.summaryfornational);

    for (let i = 0; i < Object.keys(summaryDetails).length; i++) {
      // for (let x = 0; x < Object.values(summaryDetails)[i]; x++){
      if (
        Object.values(summaryForNational)[i] !== null &&
        Object.values(summaryDetails)[i] !== undefined &&
        Object.values(summaryDetails)[i] !== "" &&
        Object.values(summaryDetails)[i] !== 0 &&
        Object.keys(summaryDetails)[i] !== "rvparkids"  &&
        // Object.keys(summaryDetails)[i] !== "population" &&
        Object.keys(summaryDetails)[i] !== "caucasian" &&
        Object.keys(summaryDetails)[i] !== "black" &&
        Object.keys(summaryDetails)[i] !== "hispanic" &&
        Object.keys(summaryDetails)[i] !== "others" &&
        Object.keys(summaryDetails)[i] !== "avgmaleinmarket" &&
        Object.keys(summaryDetails)[i] !== "avgfemaleinmarket" &&
        Object.keys(summaryDetails)[i] !== "asianpacific" &&
        Object.keys(summaryDetails)[i] !== "marketdemandformarket" &&
        Object.keys(summaryDetails)[i] !== "marketdemandfornational" &&
        // Object.keys(summaryDetails)[i] !== "potentialcampers" &&
        Object.keys(summaryDetails)[i] !== "percentageofhousehold" &&
        Object.keys(summaryDetails)[i] !== "demandsupplyratiofornational" &&
        Object.keys(summaryDetails)[i] !== "rvparkdemandscoreformarket" &&
        Object.keys(summaryDetails)[i] !== "rvparkdemandscorefornational"        
      ) {

        const validData = (Object.keys(summaryDetails)[i] !== "marketdemandformarket" || Object.keys(summaryDetails)[i] !== "marketdemandfornational" || Object.keys(summaryDetails)[i] !== "demandsupplyratiofornational") ? "" : Object.keys(summaryDetails)[i];

        let tableHeader = reqHeaderText[Object.keys(summaryDetails)[i]] || validData;
        let formatValue = Object.values(summaryDetails)[i];

        let headerValue =
          Object.keys(summaryDetails)[i] === "avgfuelcost" ||
            Object.keys(summaryDetails)[i] === "avgpricepernight" ||
            Object.keys(summaryDetails)[i] === "incomepercapita"
            ? formatValue !== null && formatValue !== undefined && formatValue !== '-' ? Config.Currency + formatValue: formatValue
            : Object.keys(summaryDetails)[i] === "avgsizeofpark"
              ? formatValue !== null && formatValue !== undefined && formatValue !== '-' ? formatValue + " Acres": formatValue
              : Object.keys(summaryDetails)[i] === "percentageofhousehold" ||
                Object.keys(summaryDetails)[i] === "avgmaleinmarket" ||
                Object.keys(summaryDetails)[i] === "avgfemaleinmarket"
                ? formatValue !== null && formatValue !== undefined && formatValue !== '-' ? formatValue + "%": formatValue
                : formatValue;

                let headerValue2 = formatValue ;
                if(summaryFor50Miles){
                  formatValue = Object.values(summaryFor50Miles)[i];
                  headerValue2 =
                            Object.keys(summaryFor50Miles)[i] === "avgfuelcost" ||
                              Object.keys(summaryFor50Miles)[i] === "avgpricepernight" ||
                              Object.keys(summaryFor50Miles)[i] === "incomepercapita"
                              ? formatValue !== null && formatValue !== undefined && formatValue !== '-' ? Config.Currency + formatValue: formatValue
                              : Object.keys(summaryFor50Miles)[i] === "avgsizeofpark"
                                ? formatValue !== null && formatValue !== undefined && formatValue !== '-' ? formatValue + " Acres": formatValue
                                : Object.keys(summaryFor50Miles)[i] === "percentageofhousehold" ||
                                  Object.keys(summaryFor50Miles)[i] === "avgmaleinmarket" ||
                                  Object.keys(summaryFor50Miles)[i] === "avgfemaleInmarket"
                                  ? formatValue !== null && formatValue !== undefined && formatValue !== '-' ? formatValue + "%": formatValue
                                  : formatValue;
                }

        let headerValue3 = '' ;
        if(summaryfor100miles){
          formatValue = Object.values(summaryfor100miles)[i];
          headerValue3 =
          Object.keys(summaryfor100miles)[i] === "avgfuelcost" ||
            Object.keys(summaryfor100miles)[i] === "avgpricepernight" ||
            Object.keys(summaryfor100miles)[i] === "incomepercapita"
            ? formatValue !== null && formatValue !== undefined && formatValue !== '-' ? Config.Currency  + formatValue: formatValue
            : Object.keys(summaryfor100miles)[i] === "avgsizeofpark"
              ? formatValue !== null && formatValue !== undefined && formatValue !== '-' ? formatValue + " Acres": formatValue
              : Object.keys(summaryfor100miles)[i] === "percentageofhousehold" ||
                Object.keys(summaryfor100miles)[i] === "avgmaleinmarket" ||
                Object.keys(summaryfor100miles)[i] === "avgfemaleInmarket"
                ? formatValue !== null && formatValue !== undefined && formatValue !== '-' ? formatValue + "%": formatValue
                : formatValue;
        }

        formatValue = Object.values(summaryForNational)[i];
        let headerValue4 =
          Object.keys(summaryForNational)[i] === "avgfuelcost" ||
            Object.keys(summaryForNational)[i] === "avgpricepernight" ||
            Object.keys(summaryForNational)[i] === "incomepercapita"
            ? formatValue !== null && formatValue !== undefined && formatValue !== '-' ? Config.Currency + formatValue: formatValue
            : Object.keys(summaryForNational)[i] === "avgsizeofpark"
              ? formatValue !== null && formatValue !== undefined && formatValue !== '-' ? formatValue + " Acres": formatValue
              : Object.keys(summaryForNational)[i] === "percentageofhousehold" ||
                Object.keys(summaryForNational)[i] === "avgmaleinmarket" ||
                Object.keys(summaryForNational)[i] === "avgfemaleInmarket"
                ? formatValue !== null && formatValue !== undefined && formatValue !== '-' ? formatValue + "%": formatValue
                : formatValue;
        summary.push(

          <TableRow key={Object.keys}>
            <TableCell>{tableHeader === "Demand Supply Ratio"
              ?
              <Tooltip title="Number of Campers per Camping Spots." placement="top" arrow>
                <span>Demand Supply Ratio<InfoOutlined className="info-tooltip" /></span>
              </Tooltip>
              :
              tableHeader}</TableCell>
            <TableCell>{headerValue}</TableCell>
            {summaryFor50Miles &&  <TableCell>{headerValue2}</TableCell> }
            {summaryfor100miles &&  <TableCell>{headerValue3}</TableCell> } 
            <TableCell>{ Object.keys(summaryForNational)[i] === "regiontype" ? "-" : headerValue4}</TableCell>
          </TableRow>

          // <tr key={Object.keys}>
          //   <td>{tableHeader}</td>
          //   <td>{headerValue}</td>
          //   <td>{headerValue}</td>
          //   <td>{headerValue}</td>
          // </tr>



        );
      }
      // }

    }
    return summary;
  };

  let summaryFor50MilesBool = updateObjectValues(marketSummary?.marketsummaryresult?.summaryfor50miles) || null;
  let summaryfor100milesBool = updateObjectValues(marketSummary?.marketsummaryresult?.summaryfor100miles) || null;



  return (
    <div>
      {isLoading ? (
        <div className="loader-wrap">
          <div className="loading loading-center"></div>
        </div>
      ) : (
        ""
      )}
      {/* <DashboardShortcuts isFrom="summary" value="2" id={marketId}/> */}
      <div className="common-table dashboard-summary">
        <Nav tabs className="market-tabls market-analysis-tab">
          <NavItem>
            <NavLink id="marketSummary"
              className={classnames({ active: tabValue.active === "1" })}
              onClick={() => {
                handleTabChange("1");
              }}
            >
              Market Summary
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              id="amenity"
              className={classnames({ active: tabValue.active === "2" })}
              onClick={() => {
                handleTabChange("2");
              }}
            >
              Amenity Analysis
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              id="seasonality"
              className={classnames({ active: tabValue.active === "3" })}
              onClick={() => {
                handleTabChange("3");
              }}
            >
              Seasonality Analysis
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              id="camping"
              className={classnames({ active: tabValue.active === "4" })}
              onClick={() => {
                handleTabChange("4");
              }}
            >
              Camping Spot Classification
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              id="Pricing"
              className={classnames({ active: tabValue.active === "5" })}
              onClick={() => {
                handleTabChange("5");
              }}
            >
              Pricing Analysis
            </NavLink>
          </NavItem>
             <NavItem>
            <NavLink
              id="activity"
              className={classnames({ active: tabValue.active === "6" })}
              onClick={() => {
                handleTabChange("6");
              }}
            >
              Activities/Attractions
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={tabValue.active}>
          <TabPane tabId="1">
            <TableContainer component={Paper} className="table-design">
              <Table sx={{ minWidth: 650 }} aria-label="simple table" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell>This Market</TableCell>
                    {summaryFor50MilesBool &&  <TableCell>Market at 50 Miles</TableCell> }
                    {summaryfor100milesBool &&  <TableCell>Market at 100 Miles</TableCell> } 
                    <TableCell>National</TableCell>

                  </TableRow>
                </TableHead>
                <TableBody>
                  {marketSummary && marketSummary.marketsummaryresult && getSummaryDetails()}
                  {marketSummary && marketSummary.marketsummaryresult && marketSummary.marketsummaryresult.length === 0 ? (
                    <TableRow>
                      <TableCell
                        style={{ textAlign: "center" }}
                        className="store-no-data"
                      >
                        No Data Available
                      </TableCell>
                    </TableRow>) : ""}
                </TableBody>
              </Table>
            </TableContainer>
          </TabPane>
          <TabPane tabId="2">
            {tabValue.active === "2" ? <AmenitiesAnalysis marketId={marketId} /> : null}
          </TabPane>
          <TabPane tabId="3">
            {tabValue.active === "3" ? <Seasonality marketId={marketId}/> : null}
          </TabPane>
          <TabPane tabId="4">
            {tabValue.active === "4" ? <CampClassification marketId={marketId}/> : null}
          </TabPane>
          <TabPane tabId="5">
            {tabValue.active === "5" ? <PricingAnalysis marketId={marketId}/> : null}
          </TabPane>
          <TabPane tabId="6">
            {tabValue.active === "6" ? <Activity marketId={marketId}/> : null}
          </TabPane>
        </TabContent>
      </div>
    </div>
  );
});

export default DashboardSummary;
